var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#F5EEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 36.4996H38.25V38.2496H13.75V36.4996ZM35.625 21.6246C35.8571 21.6246 36.0796 21.5324 36.2437 21.3683C36.4078 21.2043 36.5 20.9817 36.5 20.7496V18.1246C36.4999 17.9448 36.4444 17.7694 36.3411 17.6222C36.2378 17.475 36.0916 17.3633 35.9225 17.3021L26.2975 13.8021C26.1053 13.7326 25.8947 13.7326 25.7025 13.8021L16.0775 17.3021C15.9084 17.3633 15.7622 17.475 15.6589 17.6222C15.5556 17.7694 15.5001 17.9448 15.5 18.1246V20.7496C15.5 20.9817 15.5922 21.2043 15.7563 21.3683C15.9204 21.5324 16.1429 21.6246 16.375 21.6246H17.25V32.9996H15.5V34.7496H36.5V32.9996H34.75V21.6246H35.625ZM17.25 18.7371L26 15.5521L34.75 18.7371V19.8746H17.25V18.7371ZM27.75 32.9996H24.25V21.6246H27.75V32.9996ZM19 21.6246H22.5V32.9996H19V21.6246ZM33 32.9996H29.5V21.6246H33V32.9996Z",
    fill: "#A57BDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIcon);
export default __webpack_public_path__ + "static/media/BankIcon.752316d200eb54d129ada19f3d4cddd3.svg";
export { ForwardRef as ReactComponent };